import styled from "@emotion/styled";
import { COLOR_TERTIARY, HEADER_Z_INDEX, BOX_SHADOW_SMALL } from "../../theme";
import { ParagraphHeaderSmall } from "../../typography/Paragraph";
import { PageLoading } from "../../Loading";
import ErrorMessage, { PageErrorContainer } from "../../Error";
import { User } from "../../../../../api/src/types";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { SerializedError } from "@reduxjs/toolkit";
import Avatar from "../../Avatar";
import { formatUserFullName, formatUserInitials } from "../../../utils/format";
import DropDownButton, { DropDownOption } from "../../buttons/DropDownButton";

const Header = styled.header`
  display: flex;
  justify-content: right;
  align-items: center;
  gap: 24px;
  padding: 8px 48px;
  height: 56px;
  background-color: ${COLOR_TERTIARY};
  position: fixed;
  top: 0;
  left: 80px;
  right: 0;
  z-index: ${HEADER_Z_INDEX};
  box-shadow: ${BOX_SHADOW_SMALL};
`;

const AdminBadge = styled.div`
  background-color: #ff6b6b;
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
`;

const AdminHeader = ({
  user,
  isLoading,
  error,
}: {
  user?: User | undefined;
  isLoading?: boolean;
  error?: boolean | FetchBaseQueryError | SerializedError | undefined;
}) => {
  if (isLoading) {
    return (
      <Header>
        <PageLoading />
      </Header>
    );
  }

  if (error) {
    return (
      <Header>
        <PageErrorContainer>
          <ErrorMessage> Error loading data </ErrorMessage>
        </PageErrorContainer>
      </Header>
    );
  }

  return (
    <Header>
      <AdminBadge>Admin</AdminBadge>
      <Avatar initials={formatUserInitials(user)} />
      <ParagraphHeaderSmall>{formatUserFullName(user)}</ParagraphHeaderSmall>
      <DropDownButton
        options={[
          <DropDownOption
            key="CS"
            onClick={() => {
              window.open(
                "https://linear.app/hello-prenup/new?template=4f5f7d5a-9d2e-497b-b220-499a136946f2",
                "_blank",
              );
            }}
          >
            Customer Service
          </DropDownOption>,
          <DropDownOption
            key="Bug"
            onClick={() => {
              window.open(
                "https://linear.app/hello-prenup/new?template=bb51a52e-f76c-410c-a27d-85a2a3e633e3",
                "_blank",
              );
            }}
          >
            Bug Report
          </DropDownOption>,
          <DropDownOption
            key="Feature"
            onClick={() => {
              window.open(
                "https://linear.app/hello-prenup/new?template=37ac30c5-d75c-4d3a-9c4b-4ee41bbdc203",
                "_blank",
              );
            }}
          >
            Feature Request
          </DropDownOption>,
          <DropDownOption
            key="Question"
            onClick={() => {
              window.open(
                "https://linear.app/hello-prenup/new?template=b835259c-fd75-4faf-9d94-8852a5a0290a",
                "_blank",
              );
            }}
          >
            Question
          </DropDownOption>,
        ]}
      >
        Linear Ticket
      </DropDownButton>
    </Header>
  );
};

export default AdminHeader;
